/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 */
import React, { lazy, Suspense } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./unwrap.css";
import content from '../content.json';
import parse from 'html-react-parser';
import {
  capitalizeFirstLetter,
  formatPhoneNumber,
  addInternationalCode,
} from "../Utils";


export default function WelcomeSection({ dataJson, realtorData }) {
  const imgCDNURL = process.env.REACT_APP_RENOVATION_PROGRAM_CDN_URL;
  const realtorName = realtorData ? capitalizeFirstLetter(realtorData.name) : "";
  const realtorFirstName = realtorData ? capitalizeFirstLetter(realtorData.fisrtName) : "";
  const { heading, para, whyChooseSunwest, tailoredTitle, tailoredPara, dedicatedTitle, dedicatedPara, dreamTitle, dreamPara, dreamParanew, readyTitle, readyPara, readyPara1, readyPara2 } = dataJson;

  let mobilePhoneNumberFormatted,
    mobilePhoneNumberWithInternationalCode,
    mobilePhoneNumberInTitle,
    workPhoneNumberFormatted,
    workPhoneNumberWithInternationalCode,
    workPhoneNumberInTitle;
  try {
    mobilePhoneNumberFormatted = realtorData ? formatPhoneNumber(
      realtorData.mobilePhoneNumber
    ) : "";
    mobilePhoneNumberWithInternationalCode = realtorData ? addInternationalCode(
      realtorData.mobilePhoneNumber,
      "+1"
    ) : "";
    mobilePhoneNumberInTitle = "Contact me at " + mobilePhoneNumberFormatted;
  } catch (error) {
    console.error("Unable to get realtor mobile phone number.", error);
  }

  try {
    workPhoneNumberFormatted = realtorData ? formatPhoneNumber(realtorData.workPhoneNumber) : "";
    workPhoneNumberWithInternationalCode = realtorData ? addInternationalCode(
      realtorData.workPhoneNumber,
      "+1"
    ) : "";
    workPhoneNumberInTitle = "Contact me at " + workPhoneNumberFormatted;
  } catch (error) {
    console.error("Unable to get realtor work phone number.", error);
  }




  return (
    <>
      <div className="welcome-section">
        
        <Container>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12} className='why-choose-sunwest-col'>
              <div className="bullet-line">
              </div>
            </Col>
          </Row>
          <Row className="justify-content-between">
            <Col xs={12} sm={12} md={12} lg={8} className='renovationguidecol1'>
            <h2 className='whysunwestmaintitle'>{parse(whyChooseSunwest)}</h2>
              <div className="unwrapfirstdiv">
              <Col xs={12} sm={12} md={12} lg={3} className='tailored-col'>
                <img src={imgCDNURL + "ease.webp"} className='whysunwest-img3'></img>
                <h5 className='whysunwest-title'>{parse(tailoredTitle)}</h5>
                <p className='whysunwest-para'>{parse(tailoredPara)}</p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={3} className='dedicated-col tailored-col'>
                <img src={imgCDNURL + "vision.webp"} className='whysunwest-img3'></img>
                <h5 className='whysunwest-title'>{parse(dedicatedTitle)}</h5>
                <p className='whysunwest-para newchanges'>{parse(dedicatedPara)}</p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={3} className='dream-col tailored-col'>
                <img src={imgCDNURL + "customize.webp"} className='whysunwest-img3'></img>
                <h5 className='whysunwest-title'>{parse(dreamTitle)}</h5>
                <p className='whysunwest-para changedpara'>{parse(dreamPara)}</p>
              </Col>
              </div>
            </Col>
            <Col xs={12} sm={12} md={12} lg={3} className='renovationguidecol'>
            <img src={imgCDNURL + "renovationguideimage.webp"} className='whysunwest-img'></img>
            <div className="unwrapfirstdivnew">
            <p className='whysunwest-para newchanges'>{parse(dreamParanew)}</p>
            </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Container>
        <Row className="">
          <Col XS={12} sm={12} md={12} lg={12} className="">
          <img src={imgCDNURL + "beforeafterimage.webp"} className='beforeafterimage'></img>
          
          </Col>
        </Row>
      </Container>
      <div>
      <img src={imgCDNURL + "beforeafterimagemobile.webp"} className='beforeafterimagemobile'></img>
      </div>
    </>
  );
}
